import {ValidationRuleConfig} from '../types';
import {allRules} from "../rules";

export function parseInlineRules(rulesString: string): ValidationRuleConfig[] {
    const rules: ValidationRuleConfig[] = [];
    const ruleParts = rulesString.split('|').filter(rule => rule.trim().length > 0);

    for (const rulePart of ruleParts) {
        const [ruleName, ...valueParts] = rulePart.split(':');
        const trimmedRuleName = ruleName.trim();

        if(!allRules[trimmedRuleName]){
            throw new Error(`Unknown validation rule: ${trimmedRuleName}`);
        }

        if (valueParts.length > 0) {
            const valueString = valueParts.join(':');

            if (valueString.includes(',')) {
                rules.push({
                    rule: trimmedRuleName,
                    value: valueString.split(',').map(v => v.trim())
                });
            } else if (!isNaN(Number(valueString))) {
                rules.push({
                    rule: trimmedRuleName,
                    value: Number(valueString)
                });
            } else {
                rules.push({
                    rule: trimmedRuleName,
                    value: valueString
                });
            }
        } else {
            rules.push({rule: trimmedRuleName});
        }
    }

    return rules;
}

